import { LMSUserDetails, LoginBody } from '../interfaces/core/lmsCore';
import { services } from '../api';
import { Result } from '../shared/utils/enums';
import { v4 as uuidv4 } from 'uuid';
import tokenService from '../shared/services/tokenService';

const LMSCore = {
  /**
   * Initializes the LMS with user credentials using the new two-step authentication process.
   *
   * @param {LoginBody} authCredentials - The authentication credentials (username, password, regid, source)
   * @returns {Promise<boolean>} - A promise resolving to true if initialization is successful
   */
  initialize: async (authCredentials: LoginBody): Promise<boolean> => {
    try {
      const token = await tokenService.getToken();
      if (token) {
        return true;
      }
      
      const uuid = uuidv4();
      const appKey = process.env.REACT_APP_KEY || '';
      const headers = {
        'X-Device-UDID': uuid,
        'APP-KEY': appKey,
        'X-Device-Platform': 'web',
      };

      // Use the new two-step login process
      const res = await services.auth.twoStepLogin(authCredentials, authCredentials.password, headers);
      
      if (res.result !== Result.Success) {
        throw new Error('Login failed');
      }
      
      await tokenService.storeToken(res.content.token);
      return true;
    } catch (error) {
      console.error('error => ', error);
      return false;
    }
  },

  logout: async (): Promise<boolean> => {
    try {
      await services.auth.logout();
      return true;
    } catch (error) {
      return false;
    }
  },
};

export default LMSCore;
